import styled from 'styled-components';

const SmallInline = styled.small`
  margin-right:5px
`
export default SmallInline;